import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import NotificationItem from './NotificationItem';

const Notification = ({ className }) => {
    const notifications = useSelector(state => state.notifications);

    const generateNotification = notification => (
        <NotificationItem
            type={notification.type}
            key={notification.id}
            id={notification.id}
        >
            {notification.text}
        </NotificationItem>
    );

    return (
        <div className={className}>
            {notifications.map(generateNotification)}
        </div>
    );
};

Notification.propTypes = {
    className: PropTypes.string.isRequired
};

export default styled(Notification)`
    position: fixed;
    display: flex;
    align-items: center;
    flex-flow: column wrap;
    bottom: 38px;
    right: 0;
    left: 0;
    z-index: 99999;
`;
